export default __webpack_public_path__ + "static/media/infrastructure-code-orange.ef9a6610.svg";